import React from "react";
import * as IShadow from "src/interfaces/IShadow";
import { Shadow as ShadowType } from "src/interfaces/IShadow";
import { Stack } from "@mui/material";
import { AlenShadow } from "src/services/alen/alenDeviceConfig/utils";
import * as DeviceBadge from "../DeviceBadge";

export function HaloBadges({
  // deviceId,
  shadow,
}: {
  // deviceId: Device["device_id"];
  shadow: undefined | ShadowType;
}) {
  if (!shadow) return null;

  const lightIsOn = IShadow.nightMode(shadow);
  const locked = IShadow.lockMode(shadow);
  return (
    <Stack direction="row" gap={0.5}>
      <DeviceBadge.Light on={lightIsOn} />
      <DeviceBadge.Locked locked={!!locked} />
    </Stack>
  );
}

export function MaxBadges({
  // deviceId,
  shadow,
}: {
  // deviceId: Device["device_id"];
  shadow: undefined | ShadowType;
}) {
  if (!shadow) return null;

  const mode = IShadow.deviceMode(shadow);
  return (
    <Stack direction="row">
      <DeviceBadge.Mode mode={mode} />
    </Stack>
  );
}

export function AlenBadges({
  shadow,
  onClick = () => {},
}: {
  shadow: undefined | AlenShadow;
  onClick?: (badge: string) => void;
}) {
  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {shadow?.Mode && (
        <DeviceBadge.AlenMode
          disabled={
            shadow.Power === "Off" ||
            shadow.Lock === "Lock" ||
            shadow.Mode === "N/A"
          }
          mode={shadow.Mode}
          onClick={() => onClick("Mode")}
        />
      )}
      {shadow?.Sleep ? (
        <DeviceBadge.AlenSleep
          disabled={
            shadow.Power === "Off" ||
            shadow.Lock === "Lock" ||
            shadow.Sleep === "N/A"
          }
          sleep={shadow.Sleep}
          onClick={() => onClick("Sleep")}
        />
      ) : null}
      {shadow?.Lock && (
        <DeviceBadge.Locked
          disabled={shadow.Power === "Off"}
          locked={shadow.Lock === "Lock"}
          onClick={() => onClick("Lock")}
        />
      )}
      {shadow?.Speed && (
        <DeviceBadge.Speed
          disabled={shadow.Power === "Off" || shadow.Lock === "Lock"}
          speed={shadow.Speed}
          onClick={() => onClick("Speed")}
        />
      )}
      {shadow?.Light && (
        <DeviceBadge.AlenLight
          disabled={shadow.Power === "Off" || shadow.Lock === "Lock"}
          light={shadow.Light}
          onClick={() => onClick("Light")}
        />
      )}
    </Stack>
  );
}
